export function burst(x, y, opts = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("pusheen-burst", { detail: { x, y, ...opts } }));
}

export function burstFromEvent(e, opts = {}) {
  const x = e.clientX ?? window.innerWidth / 2;
  const y = e.clientY ?? window.innerHeight / 2;
  burst(x, y, opts);
}
